/* Visual adaptation of the existing EcomSend popup. No requests, form handling,
   coupon generation, subscription state changes or new contact lists. */
(() => {
  const configNode = document.getElementById('bb-newsletter-popup-config');
  if (!configNode) return;
  let config;
  try { config = JSON.parse(configNode.textContent); } catch (_) { return; }
  if (!/^\d+$/.test(String(config.popupId))) return;
  const selector = '#ecomsend-submit-button-' + config.popupId;
  const remembered = new WeakMap();
  const oldFlyer = 'nElg0VPfsZFp0M2gmaKY8PPItHbFlS0FhjefUwXy.png';

  function adapt() {
    document.querySelectorAll('.pp-modal').forEach(modal => {
      const submit = modal.querySelector(selector);
      const input = modal.querySelector('.ecomsend__Input__Input[type="email"]');
      const dialog = modal.querySelector('.ecomsend__Modal__CustomDialog');
      const root = modal.closest('.react-responsive-modal-root');
      const known = remembered.get(modal);
      if (!dialog || !root) return;

      // Leave the app's result/coupon screen in charge after submission.
      if (!submit || !input) {
        if (known) {
          modal.classList.remove('bb-popup-approved');
          root.classList.remove('bb-popup-approved-root');
          modal.querySelector('.bb-popup-intro')?.remove();
          if (modal.getAttribute('aria-labelledby') === 'bb-popup-title-' + config.popupId) {
            if (known.labelledby) modal.setAttribute('aria-labelledby', known.labelledby);
            else modal.removeAttribute('aria-labelledby');
          }
          const logo = modal.querySelector('.ecomsend__Modal__LogoImg');
          if (logo?.getAttribute('src')?.includes(oldFlyer)) {
            logo.src = config.image;
            logo.alt = 'Dos modelos con Silk Lipstick de Beibi Beauty';
          }
        }
        return;
      }

      if (!known) remembered.set(modal, {labelledby: modal.getAttribute('aria-labelledby')});
      const logo = dialog.querySelector('.ecomsend__Modal__LogoImg');
      if (logo && logo.getAttribute('src') !== config.image) {
        logo.src = config.image;
        logo.alt = 'Dos modelos con Silk Lipstick de Beibi Beauty';
      }
      if (!dialog.querySelector('.bb-popup-intro')) {
        const intro = document.createElement('div');
        intro.className = 'bb-popup-intro';
        const eyebrow = document.createElement('p');
        eyebrow.className = 'eyebrow';
        eyebrow.textContent = config.eyebrow;
        const heading = document.createElement('h2');
        heading.id = 'bb-popup-title-' + config.popupId;
        heading.textContent = config.heading;
        const offer = document.createElement('p');
        offer.className = 'bb-popup-offer';
        offer.textContent = config.offer;
        intro.append(eyebrow, heading, offer);
        dialog.prepend(intro);
      }
      modal.setAttribute('aria-labelledby', 'bb-popup-title-' + config.popupId);
      dialog.querySelector('.ecomsend__Modal__CloseButton')?.setAttribute('aria-label', 'Cerrar promoción');
      input.setAttribute('placeholder', 'tu@email.com');
      const button = submit.querySelector('.ecomsend__Button');
      const textNode = button?.firstElementChild?.firstChild;
      // Preserve the original button and all its handlers and loading states.
      if (textNode?.nodeType === Node.TEXT_NODE && /^suscribirse$/i.test(textNode.nodeValue.trim())) {
        textNode.nodeValue = config.button;
      }
      modal.classList.add('bb-popup-approved');
      root.classList.add('bb-popup-approved-root');
    });
  }
  let pending = false;
  const observer = new MutationObserver(() => {
    if (pending) return;
    pending = true;
    queueMicrotask(() => { pending = false; adapt(); });
  });
  observer.observe(document.body, {childList: true, subtree: true, attributes: true, attributeFilter: ['src']});
  adapt();
})();
